import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserAddPage } from './user-add';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		UserAddPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(UserAddPage),
	],
})
export class UserAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-add/user-add.module.ts